import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import NavSectionLink from '../Navbar/NavSectionLink';
import Modal from '../Modal/Modal';

import './Footer.scss';

import tel from '../../assets/tel.svg';
import logo from '../../assets/logo.png';

const Footer = () => {
    const [modalState, setModalState] = useState(false);

  return (
    <div className='footer' id="footer">
        <div className='telBlock'>
            <div className='phoneNum'>
                <img src={tel} alt="" />
                <p className='tel'>
                    +380-99-240-4750
                </p>
            </div>
            <div className='phoneNum'>
                <img src={tel} alt="" />
                <p className='tel'>
                    +380-50-643-4344
                </p>
            </div>
            <div className='btnBlock'>
                <button className='btn'  onClick={() => setModalState(true)}>
                    Leave your message
                </button>
            </div>
        </div>
       <div className='list'>
        <ul>
            <li><NavSectionLink to="program">Who are we?</NavSectionLink></li>
            <li><NavSectionLink to="part">Our partners</NavSectionLink></li>
            <li><NavSectionLink to="services">Our services</NavSectionLink></li>
            <li><RouterLink to="/news">News</RouterLink></li>
            <li><NavSectionLink to="footer">Contacts</NavSectionLink></li>
        </ul>

       </div>
       <div className='logoBlock'>
            <img src={logo} alt="" />
            <p>
                Copyright © 2026 International Innovation and Creative Industries cluster
            </p>
       </div>
       <Modal call={modalState} onDestroy={() => setModalState(false)}/>
    </div>
  )
}

export default Footer;
